import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Col, FloatingLabel, Form, Row } from "react-bootstrap";
import { useAuth } from "../../context/AuthContext";
import { useAlert } from "../../context/AlertContext";
import { useLoading } from "../../context/LoadingContext";
import { getServiceRequest } from "../../commons/ServiceRequest";
import { emptyValueObjects, findItemInArray } from "../../utils/ManageArray";
import {
  FloatingControlComponent,
  SearchSelectComponent
} from "../FormComponent";
import { initializeSetOptionDisabled } from "../../utils/InitializeSetDefault";
import TableForm from "../TableForm";
import ConfirmModal from "../ConfirmModal";
import CardDisplayComponent from "../CardDisplayComponent";

import ItemsService from "../../services/item.service";
import ParentBomsService from "../../services/parentboms.service";
import ItemStepMastersService from "../../services/itemstepmas.service";

const OperatingProceduresForm = ({ editData, onSubmitCallback }) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();
  const [showModal, setShowModal] = useState(false);
  const [validated, setValidated] = useState(false);
  const [itemMas, setItemMas] = useState([]);
  const [parentBoms, setParentBoms] = useState([]);
  const [itemStepMas, setItemStepMas] = useState([]);
  const defaultData = {
    Mas: {
      Parent_Bom_Id: "",
      Item_Id: "",
      Com_Code: user.Com_Code
    },
    Des: {
      Item_Step_Id: "",
      Item_Step_Des: "",
      Item_Take_Pic: "",
      Item_Keep_Pic: "",
      Item_Step_Priority: "",
      Item_Step_Reason: "",
      Item_Step_Require1: "",
      Item_Step_Require2: "",
      Value_Check: true,
      Com_Code: user.Com_Code
    }
  };
  const [data, setData] = useState({
    Mas: { Array: [defaultData.Mas] },
    Des: { Array: [defaultData.Des] }
  });
  const inputField = [
    { name: "Item_Step_Des", label: "ขั้นตอนการปฏิบัติงาน", type: "text" },
    { name: "Item_Step_Priority", label: "Priority", type: "text", size: 2 },
    {
      name: "Item_Step_Require1",
      label: "เงื่อนไขการข้าม1",
      type: "select",
      size: 2,
      noneAsync: true,
      options: [
        { value: true, label: "Y" },
        { value: false, label: "N" }
      ]
    },
    {
      name: "Item_Step_Require2",
      label: "เงื่อนไขการข้าม2",
      type: "select",
      size: 2,
      noneAsync: true,
      options: [
        { value: true, label: "Y" },
        { value: false, label: "N" }
      ]
    }
  ];

  const queruGetService = (serviceRequest, setDataRequest) => {
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest,
      callback: (res) => setDataRequest(res?.items || res)
    });
  };

  const handleChange = ({ value }) => {
    const arrData = data.Mas.Array;
    const findParentId = parentBoms.find(
      (parent) => parent.Item?.Id === Number(value)
    )?.Id;

    setData((prev) => ({
      ...prev,
      Mas: {
        Array: [
          {
            ...arrData[0],
            Item_Id: Number(value),
            Parent_Bom_Id: findParentId
          },
          ...arrData.slice(1)
        ]
      }
    }));
  };

  const checkValidity = () => {
    const passEmptyKey = [
      "Item_Step_Id",
      "Item_Take_Pic",
      "Item_Keep_Pic",
      "Item_Step_Reason"
    ];
    if (
      emptyValueObjects(data.Mas.Array)?.length > 0 ||
      emptyValueObjects(data.Des.Array, passEmptyKey)?.length > 0
    ) {
      showAlert({
        error: "ข้อผิดพลาด",
        message: "กรุณากรอกข้อมูลให้ครบถ้วน",
        type: "danger"
      });
      return false;
    }
    return true;
  };

  const handleValidated = (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (!form.checkValidity() || !checkValidity()) {
      event.stopPropagation();
      setValidated(true);
    } else {
      setShowModal(true);
    }
  };

  const handleSubmit = (event, { dataCallback, showCallback }) => {
    event.preventDefault();
    setShowModal(showCallback);

    if (dataCallback) onSubmitCallback(dataCallback);
  };

  useEffect(() => {
    queruGetService(ParentBomsService.getAllParentBoms(), setParentBoms);
    queruGetService(
      ItemStepMastersService.getAllItemStepMasters(),
      setItemStepMas
    );

    if (editData) {
      const findStepMas = findItemInArray(
        itemStepMas,
        "Id",
        editData.Item_Step_Id
      );

      queruGetService(ItemsService.getAllItems(), setItemMas);

      setData({
        Mas: {
          Array: [
            {
              Parent_Bom_Id: findStepMas?.Parent_Bom_Id,
              Item_Id: findStepMas?.Item_Id,
              Com_Code: editData.Com_Code
            }
          ]
        },
        Des: {
          Array: [
            (({
              Id,
              Deleted,
              createdAt,
              createdBy,
              updatedAt,
              updatedBy,
              ...rest
            }) => rest)(editData)
          ]
        }
      });
    }
  }, [editData]);

  return (
    <>
      <Form noValidate validated={validated} onSubmit={handleValidated}>
        <CardDisplayComponent
          body={{
            as: Row,
            className: "justify-content-center align-items-center",
            element: (
              <>
                <Col sm={4}>
                  <SearchSelectComponent
                    labelField="รหัสสินค้า"
                    placeholder="โปรดเลือก"
                    isInvalid={!data.Mas.Array[0].Item_Id}
                    disabled={!!editData}
                    options={initializeSetOptionDisabled(
                      { key: "Id", label: "Item_Code", dataset: itemMas },
                      { key: "Item_Id", data: itemStepMas }
                    )}
                    queryService={(query) =>
                      getServiceRequest({
                        showAlert,
                        setLoading,
                        serviceRequest: ItemsService.getAllItems(query),
                        callback: ({ items }) => setItemMas(items)
                      })
                    }
                    onChange={handleChange}
                    value={`${data.Mas.Array[0].Item_Id}`}
                  />
                </Col>

                <Col sm={7}>
                  <FloatingLabel label="ชื่อสินค้า">
                    <Form.Control
                      readOnly
                      type="text"
                      className="p-3"
                      disabled={!!editData}
                      value={
                        findItemInArray(
                          itemMas,
                          "Id",
                          data.Mas.Array[0].Item_Id
                        )?.Item_Name_TH || ""
                      }
                    />
                  </FloatingLabel>
                </Col>
              </>
            )
          }}
        />

        <CardDisplayComponent
          header={{
            title: {
              text: `${editData ? "แก้ไข" : "เพิ่ม"}ขั้นตอนการปฏิบัติงาน`
            }
          }}
          body={{
            element: (
              <TableForm
                data={data.Des.Array}
                columns={inputField}
                editForm={!!editData}
                defaultData={defaultData.Des}
                onChangeCallback={(newData) =>
                  setData((prev) => ({ ...prev, Des: { Array: newData } }))
                }
              />
            )
          }}
          footer={{
            className: "text-end",
            element: (
              <>
                <Button
                  type="submit"
                  variant="success"
                  className="px-5 py-2 text-dark rounded-pill"
                >
                  {editData ? "บันทึกการแก้ไข" : "บันทึกข้อมูล"}
                </Button>
                <ConfirmModal
                  show={showModal}
                  data={{ Mas: data.Mas, Des: data.Des }}
                  content={editData ? "edit" : "save"}
                  onSubmitCallback={handleSubmit}
                />

                <Button
                  variant="outline-success"
                  className="px-5 py-2 text-dark border-secondary rounded-pill"
                  onClick={() => navigate(-1)}
                >
                  ยกเลิก
                </Button>
              </>
            )
          }}
        />
      </Form>
    </>
  );
};

OperatingProceduresForm.propTypes = {
  editData: PropTypes.object,
  onSubmitCallback: PropTypes.func
};

export default OperatingProceduresForm;
